import { useRecoilValue } from 'recoil';
import CouchTopLine from './CouchTopLine';
import type { CanvasFrameGeometry } from '~/engine/view/TextureView';
import { PlaneView } from '~/engine/view/views/PlaneView';
import {
    redrawEventsOver,
    usePlaneRedrawTick,
} from '~/hooks/viewer/annotationOverlay';
import { viewManagerState } from '~/state/atoms/engineAtoms';

export interface CouchTopLineComponentProps {
    view: PlaneView | null;
    frame?: CanvasFrameGeometry;
}

/**
 * Forces a re-render of the line on slice scroll, zoom and a view changing
 * sides of a fusion, which are the hook's default events, or over a frame
 * only on those the frame does not announce. Scroll and zoom move the
 * world-anchored line and ghost; the fusion side decides whether the line
 * is drawn on the view at all, since it is drawn only on a view that shows
 * the primary image.
 *
 * The frame and `renderTick` are threaded down as explicit props rather than
 * left as an implicit "any re-render redraws" trigger: `CouchTopLine`'s
 * curve-preview effect depends on them explicitly, so
 * `react-hooks/exhaustive-deps` can actually check that effect's dependency
 * array instead of the effect omitting one entirely.
 */
const CouchTopLineComponent = ({ view, frame }: CouchTopLineComponentProps) => {
    const viewManager = useRecoilValue(viewManagerState);
    const renderTick = usePlaneRedrawTick(viewManager, redrawEventsOver(frame));

    return <CouchTopLine view={view} frame={frame} renderTick={renderTick} />;
};

export default CouchTopLineComponent;
